const granteeIsTNSLabel = ({ getMiddleText }) => getMiddleText('BENEFICIAIRE_ID_TNS_LABEL');

const granteeIsTNSIsDisplayed = ({ getMiddleBoolean, granteeIsSpouse }) =>
  getMiddleBoolean('BENEFICIAIRE_ID_TNS_EST_NECESSAIRE') &&
  getMiddleBoolean('BENEFICIAIRE_ID_TNS_EST_DEMANDE_DONNEES_CONTRAT') &&
  granteeIsSpouse;

export { granteeIsTNSLabel, granteeIsTNSIsDisplayed };
